(function($){
 $(function($){
     
    jQuery('.page-template-template-route .entry-title').matchHeight({byRow:true});
    jQuery('.page-template-template-route .card-content p').matchHeight();
        
    var routesList;

 	//$('.routes-list').imagesLoaded().done(function(){
		routesList = $('.routes-list').isotope({
                        layoutMode: 'fitRows',
			// specify itemSelector so stamps do get laid out
			itemSelector: '.grid-item',

			getSortData: {
				name: '[data-name]',  
				views: '[data-views] parseInt',
				district: '[data-district]',
			},
			sortBy: 'name' 
		});

		console.log('route'+routesList); 
                // remove the old group
                jQuery('.equalheights').matchHeight({ remove: true });
                // apply matchHeight on the new selection, which includes the new element
                jQuery('.equalheights').matchHeight();
	//});
        

        $(document).on('click', '#route-sort #alphabetic-sort', function () {
            $('.routes-list').isotope({ sortBy : 'name', sortAscending: true});
            updateMatchHeight();
	});
        
        $(document).on('click', '#route-sort #popular-sort', function () {	
            $('.routes-list').isotope({ sortBy : 'views', sortAscending: false});
	});
         
        $(document).on('click', '#route-sort #district-sort', function () {
            $('.routes-list').isotope({ sortBy : 'district', sortAscending: false});
            updateMatchHeight();
	}); 
  
	/*$( document.body ).on( 'post-load', function(){
		routesList.isotope();
                $.fn.matchHeight._update();
	});*/
        function updateMatchHeight(){
            $('.routes-list .cardHeight').matchHeight({ byRow: true });
            $('.routes-list .equalheights').matchHeight({ byRow: true });  
        }
 });  
})(jQuery);          